import emitter from "ccxd-ux/src/mixins/emitter";
export default {
  mixins: [emitter],
  props: {
    beforeRemove: {
      type: Function,
      required: false,
      default: null,
    },
    onRemove: {
      type: Function,
      required: false,
      default: null,
    },
    onSuccess: {
      type: Function,
      required: false,
      default: null,
    },
    onError: {
      type: Function,
      required: false,
      default: null,
    },
    onExceed: {
      type: Function,
      required: false,
      default: null,
    },
    value: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    tip: {
      type: String,
      required: false,
      default: "",
    },
  },
  created() {
    this.$emit("input", this.$attrs.fileList || []);
  },
  watch: {
    value(n) {
      if (n.length === 0) {
        this.$refs.upload.clearFiles();
      }
    },
  },
  methods: {
    onBeforeRemove(file, fileList) {
      if (this.beforeRemove) {
        return this.beforeRemove(file, fileList);
      } else {
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },
    remove(file, fileList) {
      this.onRemove(file, fileList);
      this.$emit("input", fileList);
      this.dispatch("ElFormItem", "el.form.blur", [fileList]);
    },
    success(response, file, fileList) {
      if (this.onSuccess) {
        this.onSuccess(response, file, fileList);
      } else {
        this.$message({
          type: "success",
          message: file.name + " 上传成功!",
        });
      }
      this.$emit("input", fileList);
      this.dispatch("ElFormItem", "el.form.blur", [fileList]);
    },
    error(err, file, fileList) {
      if (this.onError) {
        this.onError(err, file, fileList);
      } else {
        this.$message({
          type: "error",
          message: file.name + " 上传失败!",
        });
      }
    },
    exceed(files, fileList) {
      if (this.onExceed) {
        this.onError(files, fileList);
      } else {
        this.$message({
          type: "warning",
          message: "文件超过数量限制!",
        });
      }
    },
  },
  render() {
    return (
      <el-upload
        ref="upload"
        attrs={{
          ...this.$attrs,
          onRemove: this.remove,
          onSuccess: this.success,
          onError: this.error,
          beforeRemove: this.onBeforeRemove,
          onExceed: this.exceed,
        }}
      >
        <el-button size="small" type="primary">
          点击上传
        </el-button>
        <div slot="tip" class="el-upload__tip">
          {this.tip}
        </div>
      </el-upload>
    );
  },
};
